module.exports = __webpack_public_path__ + "6222e45e99d5f262fe00528a852bc105.svg";